import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import TitleSubtitle from '@/components/atoms/TitleSubtitle/TitleSubtitle';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';

import { PageListError, validatePageList } from './page-rules';

export type PageRulesHostForm = { show_on_pages: string; hide_on_pages: string };

const LABELS: Record<keyof PageRulesHostForm, string> = {
  show_on_pages: 'integrations.web_start.page_rules.show_on_pages',
  hide_on_pages: 'integrations.web_start.page_rules.hide_on_pages',
};

const ERRORS: Record<PageListError['code'], string> = {
  invalid: 'integrations.web_start.page_rules.invalid',
  too_long: 'integrations.web_start.page_rules.too_long',
  duplicate: 'integrations.web_start.page_rules.duplicate',
  too_many: 'integrations.web_start.page_rules.too_many',
};

const FIELDS = Object.keys(LABELS) as (keyof PageRulesHostForm)[];

const PageRules = ({ readOnly }: { readOnly?: boolean }) => {
  const { t } = useTranslation();
  const { control } = useFormContext<PageRulesHostForm>();

  const rules = {
    validate: (value: string) => {
      const error = validatePageList(value);
      return error ? t(ERRORS[error.code], { 0: error.entry }) : true;
    },
  };

  return (
    <div className="flex flex-col gap-4">
      <TitleSubtitle
        title={t('integrations.web_start.page_rules.title')}
        subtitle={t('integrations.web_start.page_rules.subtitle')}
        noGutters
      />
      {FIELDS.map((name) => (
        <FormField
          key={name}
          control={control}
          name={name}
          rules={rules}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t(LABELS[name])}</FormLabel>
              <FormControl>
                <Textarea
                  {...field}
                  value={field.value ?? ''}
                  readOnly={readOnly}
                  minRows={2}
                  maxRows={10}
                  spellCheck={false}
                  placeholder={'/shop\n/shop/*'}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
    </div>
  );
};

export default PageRules;
